/*
 * @FilePath: \uni-preset-vue-vite\src\model\user\index.js
 * @Date: 2022-10-01 21:51:11
 * @Author: itmanyong@gmail.com
 * @LastEditors: guoye
 * @LastEditTime: 2025-07-14 18:16:39
 * @Description: 用户模块
 */
import { reactive, toRefs } from 'vue'

function setup() {
  let state = reactive({
    pina_area: null, // 地区
    pina_env_var: null, // 环境信息
    pina_mcc: null, // mcc
    pina_version: null // 版本
  })

  const EnvVar = {
    setEnvVar(val) {
      state.pina_env_var = val
    }
  }

  return {
    ...toRefs(state),
    EnvVar
  }
}

const option = {
  // 配置持久化
  persist: {
    storage: localStorage,
    paths: ['pina_area', 'pina_env_var', 'pina_mcc', 'pina_version']
  }
}

export { option, setup }
